export const estadosOptions = [
  {
    value: "Fuera-de-México",
    text: "Fuera de México",
  },
  {
    value: "Aguascalientes",
    text: "Aguascalientes",
  },
  {
    value: "Baja-California",
    text: "Baja California",
  },
  {
    value: "Baja-California-Sur",
    text: "Baja California Sur",
  },
  {
    value: "Campeche",
    text: "Campeche",
  },
  {
    value: "Chiapas",
    text: "Chiapas",
  },
  {
    value: "Chihuahua",
    text: "Chihuahua",
  },
  {
    value: "Coahuila-de-Zaragoza",
    text: "Coahuila de Zaragoza",
  },
  {
    value: "Colima",
    text: "Colima",
  },
  {
    value: "Durango",
    text: "Durango",
  },
  {
    value: "Estado-de-México",
    text: "Estado de México",
  },
  {
    value: "Guanajuato",
    text: "Guanajuato",
  },
  {
    value: "Guerrero",
    text: "Guerrero",
  },
  {
    value: "Hidalgo",
    text: "Hidalgo",
  },
  {
    value: "Jalisco",
    text: "Jalisco",
  },
  {
    value: "Michoacán-de-Ocampo",
    text: "Michoacán de Ocampo",
  },
  {
    value: "Morelos",
    text: "Morelos",
  },
  {
    value: "Nayarit",
    text: "Nayarit",
  },
  {
    value: "Nuevo-León",
    text: "Nuevo León",
  },
  {
    value: "Oaxaca",
    text: "Oaxaca",
  },
  {
    value: "Puebla",
    text: "Puebla",
  },
  {
    value: "Querétaro",
    text: "Querétaro",
  },
  {
    value: "Quintana-Roo",
    text: "Quintana Roo",
  },
  {
    value: "San-Luis-Potosí",
    text: "San Luis Potosí",
  },
  {
    value: "Sinaloa",
    text: "Sinaloa",
  },
  {
    value: "Sonora",
    text: "Sonora",
  },
  {
    value: "Tabasco",
    text: "Tabasco",
  },
  {
    value: "Tamaulipas",
    text: "Tamaulipas",
  },
  {
    value: "Tlaxcala",
    text: "Tlaxcala",
  },
  {
    value: "Veracruz-de-Ignacio-de-la-Llave",
    text: "Veracruz de Ignacio de la Llave",
  },
  {
    value: "Yucatán",
    text: "Yucatán",
  },
  {
    value: "Zacatecas",
    text: "Zacatecas",
  },
];
